import styled from 'styled-components';

import { SkeletonElement } from '@notino/react-styleguide-v20';

export const SAddressSection = styled.div`
  margin-bottom: 1.25rem;
`;

export const SInputWithHeader = styled.div`
  padding-bottom: 1.25rem;
  width: 100%;
`;

export const SHeader = styled(SkeletonElement)`
  height: 1.2rem;
  width: 30%;
`;

export const SInput = styled(SkeletonElement)`
  margin: 0.5rem 0rem;
  height: 1.5rem;
`;

export const SText = styled(SkeletonElement)`
  height: 0.8rem;
  width: 40%;
`;

export const SHeading = styled(SkeletonElement)`
  margin-bottom: 1rem;
  height: 1.8rem;
`;

export const SDeliveryAddress = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const SSectionWrapper = styled.div`
  margin-top: 3rem;
`;

export const SCheckboxWithText = styled(SkeletonElement)`
  margin-bottom: 0.75rem;
  height: 1.25rem;
`;

export const SInputWrapper = styled.div<{ withRightPadding?: boolean }>`
  width: 50%;
  box-sizing: border-box;
  padding-right: ${({ withRightPadding }) => (withRightPadding ? '1.5rem' : '0')};
`;
